import { ALLOW_ADMIN_EDITING, IS_ADMIN_USER } from "./login";
import {
    EDITING_DISABLED,
    propertyChange as propertyChangeSurveyView,
    refreshTriggerAction,
    SURVEY_RESULT_CHANGED
} from "./surveyView";
/**
 *  Close runner
 * */
import { HTTP_STATUS_OK, PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import { beginLoading, endLoading } from "./loadingSpinner";
import { createBackendErrorMessages, createErrorMessages, createSuccessMessages, messagesReceived } from "./message";

import ModalDialogUtil from "../utils/ModalDialogUtil";
import { coalesce } from "../utils/ObjectUtils";
import { loadCurrentOverview, loadDetails } from "./respondentsOverview";
import { loadSurveyVersion } from "./survey";
import rest from "../common/rest";
import { RespondentsOverviewModel as roModel } from "../common/entities";
import navigate from "../common/navigate";

export const LOAD_SURVEY_RESULT_ACTION = "SURVEY_RUNNER.LOAD_SURVEY_RESULT_ACTION";
export const RUNNER_SHOW_HIDE_ACTION = "SURVEY_RUNNER.RUNNER_SHOW_HIDE_ACTION";
export const SWITCH_SENDING_SURVEY_DATA_ACTION = "SWITCH_SENDING_SURVEY_DATA_ACTION";
export const READ_ONLY_DIALOG_HIDE_ACTION = "READ_ONLY_DIALOG_HIDE_ACTION";
export const RESET_ACTION = "SURVEY_RUNNER.RESET_ACTION";
const PROPERTY_CHANGED_ACTION = "PROPERTY_CHANGED_ACTION";
export const RESULT_VALUE = "resultValue";
export const PROJECT_NAME = "projectName";
export const SHOW_RUNNER_PREVIEW = "runnerPreview";
export const SENDING_DATA_IS_IN_PROGRESS = "sendingDataIsInProgress";
export const READ_ONLY = "readOnly";
export const READ_ONLY_BY_PERMISSIONS = "readOnlyByPermissions";
export const SHOW_READ_ONLY_DIALOG = "showReadOnlyDialog";
export const LOCK_BY_USER = "lockByUser";
export const LOCKED = "locked";
export const LOCK_FROM = "lockFrom";
const REPORT_STATUS = "reportStatus";
const ADMIN_EDITABLE_REPORT_STATUSES = ["NEW", "IN_PROGRESS"];

const RUN_SURVEY_ACTION = "SURVEY_RUNNER.RUN_SURVEY_ACTION";
const ADD_LOCK_INFO_ACTION = "RESPONDENT.ADD_LOCK_INFO_ACTION";
const SURVEY_LOCKED = "Survey locked";
const SURVEY_LOCK_EXTENDED = "Survey lock extended";
const SURVEY_UNLOCKED = "Survey unlocked";

function canEditSurvey(readOnly, isAdminUser, allowAdminEditing, reportStatus) {
    const adminEditingAllowedForStatus = ADMIN_EDITABLE_REPORT_STATUSES.includes(reportStatus);
    if (reportStatus && !adminEditingAllowedForStatus) {
        return false;
    }
    return (allowAdminEditing && isAdminUser && adminEditingAllowedForStatus) || !readOnly;
}

const initialState = {
    [SHOW_RUNNER_PREVIEW]: false,
    [SWITCH_SENDING_SURVEY_DATA_ACTION]: false,
    [READ_ONLY]: false,
    [SHOW_READ_ONLY_DIALOG]: false,
    [READ_ONLY_BY_PERMISSIONS]: false
};

export default function reducer(state = initialState, action) {
    let newState;
    switch (action[TYPE_KEY]) {
        case RESET_ACTION:
            newState = Object.assign({}, initialState, {});
            break;
        case RUN_SURVEY_ACTION:
            newState = Object.assign({}, state, { [SHOW_RUNNER_PREVIEW]: action[SHOW_RUNNER_PREVIEW] });
            break;
        case LOAD_SURVEY_RESULT_ACTION: {
            const canEdit = canEditSurvey(
                action[RESULT_VALUE][READ_ONLY],
                action[IS_ADMIN_USER],
                action[ALLOW_ADMIN_EDITING],
                action[REPORT_STATUS]
            );
            newState = Object.assign({}, state, {
                [READ_ONLY_BY_PERMISSIONS]: !canEdit,
                [RESULT_VALUE]: action[RESULT_VALUE],
                [PROJECT_NAME]: action[RESULT_VALUE][PROJECT_NAME]
            });
            break;
        }
        case RUNNER_SHOW_HIDE_ACTION:
            newState = Object.assign({}, state, {
                [SHOW_RUNNER_PREVIEW]: action[SHOW_RUNNER_PREVIEW],
                [SWITCH_SENDING_SURVEY_DATA_ACTION]: false
            });
            break;
        case READ_ONLY_DIALOG_HIDE_ACTION:
            newState = Object.assign({}, state, {
                [SHOW_READ_ONLY_DIALOG]: action[SHOW_READ_ONLY_DIALOG]
            });
            break;
        case SWITCH_SENDING_SURVEY_DATA_ACTION:
            newState = Object.assign({}, state, {
                [SENDING_DATA_IS_IN_PROGRESS]: action[SENDING_DATA_IS_IN_PROGRESS]
            });
            break;
        case ADD_LOCK_INFO_ACTION:
            newState = Object.assign({}, state, {
                [READ_ONLY]: action[READ_ONLY],
                [LOCK_BY_USER]: action[LOCK_BY_USER],
                [LOCK_FROM]: action[LOCK_FROM],
                [LOCKED]: action[LOCKED],
                [SHOW_READ_ONLY_DIALOG]: action[READ_ONLY]
            });
            break;
        case PROPERTY_CHANGED_ACTION:
            newState = Object.assign({}, state, {
                [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
            });
            break;
        default:
            newState = Object.assign({}, state, {});
            break;
    }
    return newState;
}

export function hideRunner() {
    return (dispatch, getState) => {
        dispatch({
            [TYPE_KEY]: RUNNER_SHOW_HIDE_ACTION,
            [SHOW_RUNNER_PREVIEW]: false
        });
        dispatch(propertyChangeSurveyView(SURVEY_RESULT_CHANGED, false));
        dispatch(unlockSurvey());
        let { currentOverview } = getState().respondentsOverview;
        dispatch(loadDetails(currentOverview, true));
        navigate.to("/userArea/respondentDetails", {
            replace: true,
            state: true
        });
    };
}

/**
 *  Hide read-only dialog
 * */
export function hideReadOnlyDialog() {
    return (dispatch) => {
        dispatch({
            [TYPE_KEY]: READ_ONLY_DIALOG_HIDE_ACTION,
            [SHOW_READ_ONLY_DIALOG]: false
        });
    };
}

/**
 *  reset surveyRunner
 * */
export function resetSurveyRunner() {
    return {
        [TYPE_KEY]: RESET_ACTION
    };
}

/**
 * Function try to load the survey from the server, and if everything is ok, redirect to the runner
 */
export function runSurvey(survey, page, isAdminUser, allowAdminEditing) {
    return (dispatch, getState) => {
        dispatch(loadCurrentOverview(survey[roModel.reportPeriodGid]));
        dispatch(propertyChangeSurveyView("surveyCurrentPage", page));
        navigate.to("/userArea/surveyRunner", {
            replace: true,
            state: true
        });
        dispatch(runSurveyAction());
        loadSurveyVersion(survey, survey, false)(dispatch, getState);

        dispatch(loadSurveyResult(
            survey[roModel.reportPeriodGid],
            true,
            isAdminUser,
            allowAdminEditing,
            survey[roModel.status]
        ));
    };
}

/**
 * Function to save result from runner
 */
export function saveSurveyResult(result, onChangePageSaving = false) {
    ModalDialogUtil.closeModalDialogBodyFix();
    return async (dispatch, getState) => {
        const state = getState();
        // If user is closing runner from dialog result is null
        const res = result ?? state.surveyView.surveyResult;

        if (!res[roModel.reportPeriodGid]) {
            res[roModel.reportPeriodGid] = state.respondentsOverview.currentOverview.reportPeriodGid;
        }
        dispatch(switchSendingDisabled(true));
        const survey = {
            [roModel.reportPeriodGid]: res[roModel.reportPeriodGid],
            questions: res.questions,
        };

        try {
            // Async JSON creation (avoids UI freeze)
            const payload = await new Promise((resolve) =>
                setTimeout(() => resolve(JSON.stringify(survey)), 0)
            );

            const json = await rest.doPost(`/survey/surveys`, payload);

            if (!json) throw new Error("No response from server");

            Promise.all([
                dispatch(propertyChangeSurveyView(SURVEY_RESULT_CHANGED, false)),
                dispatch(switchSendingDisabled(false)),
                dispatch(messagesReceived(createSuccessMessages("saving successful")))
            ]);

            if (!onChangePageSaving) {
                const { refreshDetailsPage, currentOverview } = state.respondentsOverview;
                await dispatch(loadDetails(currentOverview, true));
                navigate.to("/userArea/respondentDetails", {
                    replace: true,
                    state: true
                });

                if (refreshDetailsPage) {
                    dispatch(propertyChangeSurveyView("refreshDetailsPage", false));
                }
                dispatch(unlockSurvey());

            }
        } catch (err) {
            let code = "1.0.1";
            try {
                code = JSON.parse(err.response ?? "{}")?.code || code;
            } catch { }
            dispatch(messagesReceived(createErrorMessages(`runner.error.${code}`)));
            dispatch(switchSendingDisabled(false));
        }
    };
}

/**
 * Function to save result from runner and stay in runner
 */
export function saveSurveyResultAndStayInRunner() {
    return (dispatch, getState) => {
        dispatch(beginLoading());
        // If user is closing runner from dialog result is null

        let result = getState().surveyView.surveyResult;

        // if there is no reportPeriodGid in property result
        if (!result[roModel.reportPeriodGid]) {
            result[roModel.reportPeriodGid] = getState().respondentsOverview.currentOverview.reportPeriodGid;
        }

        dispatch(switchSendingDisabled(true));
        const survey = {
            [roModel.reportPeriodGid]: result[roModel.reportPeriodGid],
            questions: result.questions
        };
        rest.doPost(`/survey/surveys`, JSON.stringify(survey)).then(
            (json) => {
                if (json) {
                    dispatch(messagesReceived(createSuccessMessages("saving successful")));
                    dispatch(switchSendingDisabled(false));
                    dispatch(propertyChangeSurveyView(SURVEY_RESULT_CHANGED, false));
                    dispatch(endLoading());
                } else {
                    dispatch(messagesReceived(createErrorMessages(json)));
                    dispatch(switchSendingDisabled(false));
                    dispatch(endLoading());
                }
            },
            (reason) => {
                let error = JSON.parse(reason.response);
                dispatch(messagesReceived(createErrorMessages(`runner.error.${error.code}`)));
                dispatch(switchSendingDisabled(false));
                dispatch(endLoading());
            }
        );
    };
}

/**
 * Save successful action
 */
function runSurveyAction() {
    return {
        [TYPE_KEY]: RUN_SURVEY_ACTION,
        [SHOW_RUNNER_PREVIEW]: true
    };
}

/**
 * Load result for current running survey
 */
export function loadSurveyResult(reportingPeriodId, aquireLock, isAdminUser, allowAdminEditing, reportStatus) {
    return (dispatch, getState) => {
        rest.doGet(`/survey/surveys/result/${reportingPeriodId}`).then(
            (json) => {
                const status = reportStatus ?? getState().respondentsOverview.currentOverview?.[roModel.status];
                const readOnly = !canEditSurvey(json.readOnly, isAdminUser, allowAdminEditing, status);
                if (json[roModel.reportPeriodGid]) {
                    dispatch(resultLoaded(json, isAdminUser, allowAdminEditing, status));
                    dispatch(propertyChangeSurveyView(EDITING_DISABLED, readOnly));
                    dispatch(propertyChange(READ_ONLY, readOnly));
                    refreshTriggerAction()(dispatch, getState);
                } else {
                    dispatch(messagesReceived(createErrorMessages(json)));
                }

                if (aquireLock && canEditSurvey(json.readOnly, isAdminUser, allowAdminEditing, status)) {
                    dispatch(lockEditingOfSurvey(json[roModel.reportPeriodGid]));
                }
            },
            (reason) => {
                dispatch(messagesReceived(createBackendErrorMessages(reason)));
            }
        );
    };
}

function resultLoaded(result, isAdminUser, allowAdminEditing, reportStatus) {
    return {
        [TYPE_KEY]: LOAD_SURVEY_RESULT_ACTION,
        [RESULT_VALUE]: result,
        [IS_ADMIN_USER]: isAdminUser,
        [ALLOW_ADMIN_EDITING]: allowAdminEditing,
        [REPORT_STATUS]: reportStatus
    };
}

/**
 * Save successful action
 */
function switchSendingDisabled(value) {
    return {
        [TYPE_KEY]: SWITCH_SENDING_SURVEY_DATA_ACTION,
        [SENDING_DATA_IS_IN_PROGRESS]: value
    };
}

/**
 * extend lock on survey
 */
export function extendLockEditingOfSurvey() {
    return (dispatch, getState) => {
        let reportPeriodId = getState().surveyView.surveyResult.reportPeriodGid;
        let shouldSurveyBeLocked = getState().respondentsOverview.currentOverview.status === "SENT" ? false : true;
        // If expired, reportPeriodId is undefined so not calling rest
        if (typeof reportPeriodId !== "undefined" && shouldSurveyBeLocked) {
            rest.doPut(`/survey/surveys/overviews/${reportPeriodId}/lock`).then(
                (json) => {
                    if (json) {
                        dispatch(addLockInfos(json));
                        dispatch(messagesReceived(createSuccessMessages(SURVEY_LOCK_EXTENDED)));
                    }
                },
                (reason) => {
                    if (reason.status === 401) {
                        navigate.to("/");
                    } else {
                        let error = JSON.parse(reason.response);
                        dispatch(messagesReceived(createErrorMessages(`runner.error.${error.code}`)));
                    }
                }
            );
        }
    };
}

/**
 * Lock survey
 */
export function lockEditingOfSurvey(reportId) {
    return (dispatch, getState) => {
        let reportPeriodId = coalesce(reportId, getState().surveyView.surveyResult.reportPeriodGid);
        if (typeof reportPeriodId !== "undefined") {
            rest.doPost(`/survey/surveys/overviews/${reportPeriodId}/lock`).then(
                (json) => {
                    if (json) {
                        dispatch(addLockInfos(json));
                        dispatch(messagesReceived(createSuccessMessages(SURVEY_LOCKED)));
                    }
                },
                (reason) => {
                    dispatch(messagesReceived(createBackendErrorMessages(reason)));
                }
            );
        }
    };
}

/**
 * Get locking info for given survey
 */
export function lockInfoOfSurvey(survey, page, isAdminUser, allowAdminEditing) {
    let reportId = survey[roModel.reportPeriodGid];

    return (dispatch, getState) => {
        let reportPeriodId = coalesce(reportId, getState().surveyView.surveyResult.reportPeriodGid);
        if (typeof reportPeriodId !== "undefined") {
            rest.doGet(`/survey/surveys/overviews/${reportPeriodId}/lock`).then(
                (json) => {
                    if (json) {
                        dispatch(addLockInfos(json));
                        if (!json.readOnly) {
                            dispatch(runSurvey(survey, page, isAdminUser, allowAdminEditing));
                        }
                    }
                },
                (reason) => {
                    dispatch(messagesReceived(createBackendErrorMessages(reason)));
                }
            );
        }
    };
}

/**
 * Unlock survey
 */
export function unlockSurvey() {
    return (dispatch, getState) => {
        const state = getState();
        let reportPeriodGid = state.surveyView.surveyResult.reportPeriodGid;
        let readOnly = state.surveyView.surveyResult.readOnly;
        let isAdminUser = state.login[IS_ADMIN_USER];
        let allowAdminEditing = state.login[ALLOW_ADMIN_EDITING];
        const reportStatus = state.respondentsOverview.currentOverview?.[roModel.status];
        if (canEditSurvey(readOnly, isAdminUser, allowAdminEditing, reportStatus) && typeof reportPeriodGid !== "undefined") {
            rest.doDelete(`/survey/surveys/overviews/${reportPeriodGid}/lock`).then(
                (json) => {
                    if (json.status === HTTP_STATUS_OK) {
                        dispatch(
                            addLockInfos({
                                [LOCKED]: false,
                                [READ_ONLY]: false
                            })
                        );
                        dispatch(messagesReceived(createSuccessMessages(SURVEY_UNLOCKED)));
                    } else {
                        dispatch(messagesReceived(createErrorMessages(json)));
                    }
                },
                (reason) => {
                    dispatch(messagesReceived(createBackendErrorMessages(reason)));
                }
            );
        }
    };
}

/**
 * Put lock info to state
 */
export function addLockInfos(lockInfo) {
    return {
        [TYPE_KEY]: ADD_LOCK_INFO_ACTION,
        [READ_ONLY]: lockInfo[READ_ONLY],
        [LOCK_BY_USER]: lockInfo[LOCK_BY_USER],
        [LOCK_FROM]: lockInfo[LOCK_FROM],
        [LOCKED]: lockInfo[LOCKED]
    };
}

export function propertyChange(propertyName, propertyValue) {
    return {
        [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
        [PROPERTY_NAME]: propertyName,
        [PROPERTY_VALUE]: propertyValue
    };
}
